module.exports = __webpack_public_path__ + "img/dnwc-currency-guide-en.b3b414e2.png";